import Spinner from './Spinner';
import { clsx } from 'clsx';

const Loading = ({
  text = 'Carregando...',
  fullScreen = false,
  className,
}) => {
  if (fullScreen) {
    return (
      <div className="fixed inset-0 bg-white dark:bg-gray-900 flex items-center justify-center z-50">
        <div className="flex flex-col items-center">
          <Spinner size="xl" className="text-primary-600" />
          <p className="mt-4 text-gray-600 dark:text-gray-400">{text}</p>
        </div>
      </div>
    );
  }

  return (
    <div className={clsx('flex flex-col items-center justify-center py-12', className)}>
      <Spinner size="lg" className="text-primary-600" />
      <p className="mt-4 text-gray-600 dark:text-gray-400">{text}</p>
    </div>
  );
};

export default Loading;
